/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDayOff } from '../../models/api-response-day-off';
import { DayOff } from '../../models/day-off';

export interface CreateDayOff$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: DayOff
}

export function createDayOff(http: HttpClient, rootUrl: string, params: CreateDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDayOff>> {
  const rb = new RequestBuilder(rootUrl, createDayOff.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDayOff>;
    })
  );
}

createDayOff.PATH = '/v1/api/ui/dayOff';
